<template>
    <div>
        <!-- RD-166: подразделение, год и лента месяцев над iframe; выгрузки нет. -->
        <div class="ds-analytics-toolbar">
            <DepartmentsTree mode="analytics" class="z-[51]" />
            <Months />
        </div>

        <iframe
        v-if="url"
        :src="url"
        class="w-screen border-0 iframe"
        />
       <div class="flex min-h-[70vh] items-center justify-center" v-if="loading">
         <Loader />
       </div>
    </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref, computed, watch } from 'vue';
import dayjs from 'dayjs';
import Loader from '@/ui/Loader.vue';
import Months from '@/components/header/Months.vue'
import DepartmentsTree from '@/components/header/DepartmentsTree.vue'
import { useScheduleStore } from '@/stores/scheduleStore'
import { useExchangeStore } from '@/stores/exchangeStore';

const store = useScheduleStore()
const exchangeStore = useExchangeStore()
const url = ref<string | null>(null)
const loading = ref(false)
const currentDate = computed(() => store.currentScheduleDate)
// Выбранная в Аналитике голова либо магазин общего контекста; dashboard по ID выбирает backend.
const currentDepartmentId = computed(() => store.analyticsGroup?.id ?? store.currentDepartment?.id)
// Запрос только при допустимом подразделении; одинаковый ключ не порождает повторный запрос.
const requestKey = computed(() =>
    currentDepartmentId.value ? `${currentDepartmentId.value}|${currentDate.value.format('YYYY-MM')}` : null,
)
let analyticsRequest = 0

// На входе будущий период нормализуется к текущему месяцу.
const today = dayjs()
if (currentDate.value.isAfter(today, 'month')) store.goToMonth(today.year(), today.month())


const getAnalytics = async () => {
        const request = ++analyticsRequest

        loading.value = true
        const from = dayjs(currentDate.value).startOf('month').format('YYYY-MM-DD')
        const to = dayjs(from).endOf('month').format('YYYY-MM-DD')
        const data = {
            from,
            to,
            department: currentDepartmentId.value
        }
        try {
            const res = await exchangeStore.fetchMetabaseUrl(data)
            if (request !== analyticsRequest) return

            url.value = typeof res === 'string' && res.includes('http') ? res : null
        } catch {
            if (request === analyticsRequest) url.value = null
        } finally {
            if (request === analyticsRequest) loading.value = false
        }
    }

    watch(requestKey, (key) => {
        if (key) {
            getAnalytics()
            return
        }
        analyticsRequest++
        url.value = null
        loading.value = false
    })

    onMounted(() => {
        if(requestKey.value) getAnalytics()
    })

    onBeforeUnmount(() => {
        analyticsRequest++
    })

</script>

<style scoped>
    .iframe {
        /* шапка + тулбар аналитики (32 px контролы + 2×16 px отступы + 1 px линия) */
        height: calc(100vh - var(--main-header-height) - 65px);
    }
</style>
